import { supabase } from '@/lib/supabase'

export async function updateNotificationSettings(settings) {
  const payload = {}
  const map = {
    bracket_updates_enabled: 'p_bracket_updates_enabled',
    prize_notifications_enabled: 'p_prize_notifications_enabled',
    group_notifications_enabled: 'p_group_notifications_enabled',
    push_enabled: 'p_push_enabled',
    new_tournament_enabled: 'p_new_tournament_enabled',
    picks_open_enabled: 'p_picks_open_enabled',
    lock_reminder_enabled: 'p_lock_reminder_enabled',
    streak_milestone_enabled: 'p_streak_milestone_enabled',
    group_messages_enabled: 'p_group_messages_enabled',
  }
  Object.entries(settings).forEach(([key, value]) => {
    if (value === undefined) return
    const rpcKey = map[key]
    if (rpcKey) payload[rpcKey] = value
  })
  const { data, error } = await supabase.rpc('update_notification_settings', payload)
  if (error) throw error
  return data
}

export async function sendGroupMessage(groupId, body) {
  const { data, error } = await supabase.rpc('send_group_message', {
    p_group_id: groupId,
    p_body: body,
  })
  if (error) throw error
  return data
}

export async function sendLockReminders(hoursBefore = 24) {
  const { data, error } = await supabase.rpc('send_lock_reminders', {
    p_hours_before: hoursBefore,
  })
  if (error) throw error
  return data
}
